export default __webpack_public_path__ + "static/media/productexcel.f8513aac.xls";